import cx from 'classnames';

export const getFieldContainerStylesAsClassName = (
  disabled = false,
  isFocused = false,
  isInvalid = false,
  readOnly = false,
  hasBorder = true,
  hasCaret = true
) => {
  return cx(
    'overflow-hidden',
    'border-[1.5px]',
    'border-solid',
    'border-primary-main',
    'bg-white',
    'rounded-full',
    'flex',
    'w-full',
    'hover:border-primary-dark',
    'active:border-primary-dark',
    {
      'bg-gray-xxlight border-primary-main': readOnly || disabled,
      'bg-error-light border-error-main': isInvalid,
      'border-primary-dark': isFocused,
      'border-none hover:border-none': !hasBorder,
      'caret-transparent': !hasCaret,
    }
  );
};
